
import axios from 'axios';
import { SV_SOJ_ORCMOCK_ADDRESS,SV_SOJ_SVDJMOCK_ADDRESS,SV_SOJ_SVDJMOCK_BRIDGE } from '../../constants';
const _ = require('lodash')

const headers = {'Content-Type': 'application/json'}
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

/*
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidateOld = (values ) => {
  return sleep(1000).then(() => {
    console.log('asyncValidate fromdata data start')
    console.log(values)
    console.log('asyncValidate fromdata data ends')
    // simulate server latency
    if (['john', 'paul', 'george', 'ringo'].includes(values.username)) {
      throw { username: 'That username is taken' }
    }
  })
}
*/

/*
const adtf = (dtoken)=>{
  const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverifyme`
 
 console.log('sv***FEB5 digital code  digitalCode', dtoken)

 const  digitalCode = dtoken
 let email = null
  const bodyDelete = {
      "email": email ? email :"suelb22@yahoo.com",
      "customerId": "-131",
      "attempt": "1",
      "status": "OK",
      "digitalCode": digitalCode ? digitalCode : "912593"


  }
  return axios.post(urlDelete, bodyDelete, {headers:headers})
  .then(
      r => {
        let  errmsg = "Invalid dcode"
          if(r.data.length>0){
            const ar = r.data
            const ob = ar[0]
            if( ob['status' === 'FAIL']){
            
              errmsg = 'SV Invalid Code'

            
              return errmsg

            }else{
              return undefined

            }
           

          }else {
            errmsg = "Invalid dcode-Server error"

            
            return errmsg
              
          }
      }
  ).catch(
      e=>{ return "catch Server e "}
  )

}
*/
const asyncValidateSpaces = (values)=>{
  const urlDelete = `${SV_SOJ_ORCMOCK_ADDRESS}/account/svverifyme`
 /*
  const bodyDeleteOld = {
      "id": (nameQParam? nameQParam:3)
     }
 */
 console.log('sv***FEB5 values.digitalCode', values)
 //const dtoken =     values.digitalCode
 const {email, digitalCode} = values

 //svstep1  email and digital code length is less than 6 return plan message

 let sob = {}
let ef = false
if (!email || !digitalCode){
  ef = true
  console.log("Sv Ef happended email or digitalCode ubdefined ")
}
 if( email && email.length < 5){
  sob.email = 'Valid Email Required'
  ef = true
  console.log("Sv Ef happended email", sob)
  
 }

 



  const bodyDelete = {
      "email": email ? email :"suelb22@yahoo.com",
      "customerId": "-131",
      "attempt": "1",
      "status": "OK",
      "digitalCode":  "912593"


  }
  return axios.post(urlDelete, bodyDelete, {headers:headers})
  .then(
      r => {
        const errors = {}

        const errorsBypassDigitalCode = {}
          let ob = null
          if(r.data){
            if(_.isArray(r.data)){
              if(r.data.length > 0){
                const ar = r.data
                console.log('sv******r.data', r.data)
                ob = ar[0]
               
              }

            }else if (_.isObject(r.data)){
              ob = r.data
            }else{
            console.log('digitalCode Bypassed NotImplemented')
              errors.digitalCode = 'InvalodSVHX Code'
              return errorsBypassDigitalCode

            }
           
           
            if( ob['status'] === 'FAIL'){
              errors.email = 'Valid Email Required'
              errors.digitalCode = 'InvalodSVSVS Code'
              return errorsBypassDigitalCode

            
              //return errors

            }else{
              const svvalidob = {}
              return svvalidob

            }
           

          }else {
            errors.email = 'Valid Email Required'
            errors.digitalCode = 'InvalXd r.data not ther  Code'

            
            //return errors
            return errorsBypassDigitalCode
              
          }
      }
  ).catch(
      e=>{ throw { email: 'That username is takenBad email' }}
  )

}
export default asyncValidateSpaces
